module.exports = typeof window == 'object';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-web-tools/next-rio/node_modules/core-js/internals/engine-is-browser.js
// module id = 5719
// module chunks = 11